import { BoutiqueActionTypes } from "./constants";
import { BoutiqueItem } from "./types";

export const loadBoutiques = () => ({
  type: BoutiqueActionTypes.LOAD_BOUTIQUES,
});

export const loadBoutiquesError = (error: string) => ({
  type: BoutiqueActionTypes.LOAD_BOUTIQUES_ERROR,
  payload: { error },
});

export const setBoutiques = (list: BoutiqueItem[]) => ({
  type: BoutiqueActionTypes.SET_BOUTIQUES,
  payload: { list },
});

/** Pass `null` to clear the filter (= "Toutes les boutiques"). */
export const changeBoutique = (boutiqueId: string | null) => ({
  type: BoutiqueActionTypes.CHANGE_BOUTIQUE,
  payload: boutiqueId,
});

export const updateSelectedBoutique = (boutiqueId: string | null) => ({
  type: BoutiqueActionTypes.UPDATE_SELECTED_BOUTIQUE,
  payload: boutiqueId,
});

export const createBoutique = (input: {
  name: string;
  country?: string;
  description?: string;
}) => ({
  type: BoutiqueActionTypes.CREATE_BOUTIQUE,
  payload: input,
});

export const createBoutiqueSuccess = (boutique: BoutiqueItem) => ({
  type: BoutiqueActionTypes.CREATE_BOUTIQUE_SUCCESS,
  payload: { boutique },
});

export const createBoutiqueError = (error: string) => ({
  type: BoutiqueActionTypes.CREATE_BOUTIQUE_ERROR,
  payload: { error },
});

export const updateBoutique = (input: {
  id: string;
  name?: string;
  country?: string;
  description?: string;
}) => ({
  type: BoutiqueActionTypes.UPDATE_BOUTIQUE,
  payload: input,
});

export const updateBoutiqueSuccess = (boutique: Partial<BoutiqueItem> & { id: string }) => ({
  type: BoutiqueActionTypes.UPDATE_BOUTIQUE_SUCCESS,
  payload: { boutique },
});

export const updateBoutiqueError = (error: string) => ({
  type: BoutiqueActionTypes.UPDATE_BOUTIQUE_ERROR,
  payload: { error },
});

export const deleteBoutique = (id: string) => ({
  type: BoutiqueActionTypes.DELETE_BOUTIQUE,
  payload: { id },
});

export const deleteBoutiqueSuccess = (id: string) => ({
  type: BoutiqueActionTypes.DELETE_BOUTIQUE_SUCCESS,
  payload: { id },
});

export const deleteBoutiqueError = (error: string) => ({
  type: BoutiqueActionTypes.DELETE_BOUTIQUE_ERROR,
  payload: { error },
});
